import React from "react";
import { Layout, Tabs } from "antd";
import { Images } from "../";
import Loading from "../common/Loading";
import { withRouter } from "react-router";
import { AppConfig } from "../../helpers";


import { connect } from "react-redux";
import {
  init,
  loadSportCategories,
  removeDisabledCategoriesTournaments,
  setTounament,
} from "../../redux/actions/categoriesActions";
import {
  loadSportTypes,
  removeDisabledSportTypes,
  setSport,
} from "../../redux/actions/sportTypesActions";


const { TabPane } = Tabs;


class CategoriesMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { index: 0 };
  }

  onSportTypeClick = (item) => {
    const {
      history,
      setSport,
      feedName,
      loadSportCategories,
      removeDisabledSportTypes,
      feedId,
      match,
    } = this.props;
    // if (
    //   (item.feed.feedId == 6 && item.sport.sportId == 1) ||
    //   item.feed.feedId == 5
    // ) {
      history.push(
        `/${feedName}/${feedId}/${item.sport.sportId}/${item.sport.sportDisplayName.toLowerCase()}`
      );
    // }
    // else {
    //   history.push(
    //     `/${feedName}/${feedId}/${item.sport.sportId}/${item.sport.sportDisplayName}/today/0`
    //   );
    // }

    setSport(item);
    removeDisabledSportTypes();

    const request = {
      Data: {
        Feed: { FeedId: Number(item.feed.feedId) },
        Sport: { SportId: Number(item.sport.sportId) },
      },
    };
    loadSportCategories(request);
  };

  onSportClick(sport) {
    //if (sport.sport.sportId != sportData.sport.sportId) {
    this.onSportTypeClick(sport);
  }

  getTabPanelBySport(sport) {
    const sportFeedId = sport.feed.feedId
    const sportId = sport.sport.sportId;
    const sportName = sport.sport.sportDisplayName;
    const { sportTypesIcons } = this.props;
    const img =  sportTypesIcons && sportTypesIcons.filter((item) => {
      return item.sportTypesIconsID == sportId && item.feedId == sportFeedId;
    });
    const src = () => {
      return img && img[0] ? `${img[0].sportTypesIconsName}?id=${img[0].imageVersion}` : ''; //`${AppConfig.api.sportIcons}${sportName.toString().replace(/ /g, '')}.webp`
    };
    return (
      <TabPane
        tabBarGutter={200}
        tab={
          <section className="sport-icons-container" onClick={() => this.onSportClick(sport)}
          >
            <img
              className="tab mobile-view-images"
              src={src()}
              alt="sport-icons"
            />
            <span className="sport-display-name" style={{ color: `${sport.sportColor}` }}>{sportName}</span>
          </section>

        }
        key={sportId}
      />
    );
  }

  render() {
    const {
      mobileMenuOpen,
      openMobileMenu,
      sportCategories,
      sportTopLeagues,
      sportTypes,
      sportTypesError,
      categoriesError,
      loadingSportTypes,
      match,
    } = this.props;

    const { params } = match
    const currentSport = sportTypes && sportTypes.length > 0 && sportTypes.filter((item) => {
      return Number(item.sport.sportId) == Number(params.sport)
    })
    if (loadingSportTypes) {
      return <Loading />;
    }
    if (sportTypesError) {
      return <div>{sportTypesError}</div>;
    }
    return (

      <>
        <div id="sport-categories-menu">
          {/* <img /> */}
          <Tabs
            className="ant-tabs-ink-bar-border-color"
            style={{ '--ink-bar-color': currentSport && currentSport[0] && currentSport[0].sportColor ? currentSport[0].sportColor : 'var(--white)'}}
            size="large"
            // defaultActiveKey={params.sport}
            activeKey={params.sport}
          >
            {sportTypes && sportTypes.map((sport) => {
              return this.getTabPanelBySport(sport);
            })}

          </Tabs>
          {/* <img /> */}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    sportCategories: state.categories.sportCategories,
    sportTopLeagues: state.categories.sportTopLeagues,
    tournamentData: state.categories.tournamentData,
    loadingSportCategories: state.categories.loadingSportCategories,
    categoriesError: state.categories.error,
    sportTypesError: state.sportTypes.error,
    loadingSportTypes: state.sportTypes.loadingSportTypes,
    sportData: state.sportTypes.sportData,
    sportTypes: state.sportTypes.sportTypes,
    appMatch: state.app.match,
    mobileMenuOpen: state.app.mobileMenuOpen,
    connected: state.signalr.connected,
    feedName: state.app.feedName,
    feedId: state.app.feedId,
    sportTypesIcons: state.general.sportTypesIcons
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // openMobileMenu: (open) => dispatch(openMobileMenu(open)),
    loadSportCategories: (request) => {
      dispatch(loadSportCategories(request));
    },
    setTounament: (item) => {
      dispatch(setTounament(item));
    },
    init: () => {
      dispatch(init());
    },
    setSport: (item) => {
      dispatch(setSport(item));
    },
    loadSportTypes: (request) => {
      dispatch(loadSportTypes(request));
    },
    removeDisabledSportTypes: () => {
      dispatch(removeDisabledSportTypes());
    },
    removeDisabledCategoriesTournaments: () => {
      dispatch(removeDisabledCategoriesTournaments());
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CategoriesMenu)
);
